module.exports = __webpack_public_path__ + "img/40f2.f7ccf92c.jpg";